export default "__VITE_ASSET__DeqCKB9K__"